module.exports = __webpack_public_path__ + "static/media/02.7f6ff1ad.jpg";